import React from 'react';
import { useTranslation }              from 'react-i18next';

interface CustomRadioboxProps {
    checked: boolean;
    label: string;
    onCheckedChange: (checked: boolean) => void;
    class?: string;
}

const CustomRadiobox: React.FC<CustomRadioboxProps> = ({ checked, label, onCheckedChange, class: className = '' }) => {
    const { t } = useTranslation();

    return (
        <label className={"custom-radiobox"}>
            <input
                type="radio"
                checked={checked}
                onChange={(e) => onCheckedChange(e.target.checked)}
            />
            <span className="checkmark-radio"></span>
            <div className={`checkbox-radio-label ${className}`}>{t(label)}</div>
        </label>
    );
}

export default CustomRadiobox;